import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Users, Trophy } from "lucide-react";

interface TeamMember {
  id: string;
  name: string;
  totalTickets: number;
  resolvedTickets: number;
  resolutionRate: number;
  avgResolutionHours: number;
}

interface TeamPerformanceTableProps {
  teamPerformance: TeamMember[];
}

export const TeamPerformanceTable = ({ teamPerformance }: TeamPerformanceTableProps) => {
  if (!teamPerformance || teamPerformance.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Performance da Equipe
          </CardTitle>
          <CardDescription>Top 5 atendentes do período</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-8">
            Nenhum dado disponível para o período selecionado
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Performance da Equipe
        </CardTitle>
        <CardDescription>Top 5 atendentes do período</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[50px]">#</TableHead>
              <TableHead>Atendente</TableHead>
              <TableHead className="text-center">Total</TableHead>
              <TableHead className="text-center">Resolvidos</TableHead>
              <TableHead>Taxa de Resolução</TableHead>
              <TableHead className="text-right">Tempo Médio</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {teamPerformance.map((member, index) => (
              <TableRow key={member.id}>
                <TableCell>
                  {index === 0 && <Trophy className="h-4 w-4 text-yellow-500" />}
                  {index !== 0 && <span className="text-muted-foreground">{index + 1}</span>}
                </TableCell>
                <TableCell className="font-medium">{member.name}</TableCell>
                <TableCell className="text-center">
                  <Badge variant="outline">{member.totalTickets}</Badge>
                </TableCell>
                <TableCell className="text-center">
                  <Badge className="bg-green-500/10 text-green-700 dark:text-green-400">
                    {member.resolvedTickets}
                  </Badge>
                </TableCell>
                <TableCell>
                  <div className="space-y-1">
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-muted-foreground">{member.resolutionRate.toFixed(1)}%</span>
                    </div>
                    <Progress value={member.resolutionRate} className="h-2" />
                  </div>
                </TableCell>
                <TableCell className="text-right font-mono text-sm">
                  {member.avgResolutionHours.toFixed(1)}h
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
